<div class="alert alert-warning" role="alert">
  <i class="fad fa-debug"></i> Sorteervelden
  <div *ngFor="let field of sortOption.Fields" class="small">
    <span *ngIf="!descending(field)"><i class="fas fa-sort-alpha-down"></i></span> 
    <span *ngIf="descending(field)"><i class="fas fa-sort-alpha-down-alt"></i></span> 
    {{withoutDirection(field)}} = <ngx-json-viewer [json]="sortService.getItemValue(item, withoutDirection(field), alternateDataKey, alternateData)" [expanded]="true"></ngx-json-viewer>
  </div>
</div>